import { TableSkeleton } from "components/PortalLoading";
import useFetchSubjectGroups from "api/SubjectGroupResource/useFetchSubjectGroups";
import Admin2 from "layouts/Admin2";
import { useState } from "react";
import { DataTable } from "components/PortalDataTable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import EditSubjectGroup from "./EditSubjectGroup";
import DeleteSubjectGroup from "./DeleteSubjectGroup";
import ViewSubjectGroupStudents from "./ViewSubjectGroupStudents";
import { rowsPerPageOptions } from "utils/constants";

const SubjectGroups = () => {
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [firstPage, setFirstPage] = useState(0);
	const [page, setPage] = useState(1);

	const { data: subjectGroups, isLoading: isLoadingSubjectGroups } =
		useFetchSubjectGroups({
			page: page,
			rows_per_page: rowsPerPage,
		});

	const tableData = subjectGroups?.data?.data?.map((subjectGroup) => ({
		id: subjectGroup.id,
		name: subjectGroup.name,
		numberOfStudents: subjectGroup?.assigned_users_count,
		created_by:
			subjectGroup?.user?.first_name + " " + subjectGroup?.user?.last_name,
		institution_name: subjectGroup?.user?.institutions[0]?.name,
		institution_contactNumber:
			subjectGroup?.user?.institutions[0]?.contact_number,
		institution_address: subjectGroup?.user?.institutions[0]?.address,
	}));

	const totalRecords = subjectGroups?.data?.total;

	const onBasicPageChange = (event) => {
		setFirstPage(event.first);
		setRowsPerPage(event.rows);
		setPage(event.page + 1);
	};

	const subjectTemplate = (row) => {
		return (
			<p className="portal-subject-name">
				<span>{row?.name}</span>
				<ViewSubjectGroupStudents
					id={row.id}
					name={row.name}
					numberOfStudents={row?.numberOfStudents}
				/>
			</p>
		);
	};

	const actionBodyTemplate = (row) => {
		return (
			<div className="flex items-center gap-1 text-akgreen">
				<span className="h-8 w-8 flex justify-center items-center border-r border-b border-gray-300">
					<EditSubjectGroup
						id={row.id}
						name={row.name}
					/>
				</span>

				<span className="h-8 w-8 flex justify-center items-center border-l border-b border-gray-300">
					<DeleteSubjectGroup id={row.id} />
				</span>
			</div>
		);
	};

	return (
		<Admin2 pageTitle="Subject groups">
			{isLoadingSubjectGroups ? (
					<TableSkeleton label="Loading subject groups…" columns={["Group", "Students", "Actions"]} />
			) : (
				<div
					className="portal-page-container"

				>
					<DataTable
						value={tableData}
						tableClassName="font-sans text-sm"
						autoLayout
					>
						<Column
							header="Name"
							sortable
							headerClassName="text-center"
							body={subjectTemplate}
						/>
						<Column
							field="created_by"
							header="Created by"
							sortable
						/>
						<Column
							field="institution_name"
							header="Institution"
							sortable
						/>
						<Column
							header="Actions"
							headerClassName="text-center"
							body={actionBodyTemplate}
						/>
					</DataTable>
					<Paginator
						first={firstPage}
						rows={rowsPerPage}
						totalRecords={totalRecords}
						rowsPerPageOptions={rowsPerPageOptions}
						onPageChange={onBasicPageChange}
						pageLinkSize={4}
						className="font-sans bg-white mt-4"
						template={{
							layout:
								"FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
						}}
					/>
				</div>
			)}
		</Admin2>
	);
};

export default SubjectGroups;
